import type { Point } from '../../hex/types';

export type Bounds = { left: number; right: number; top: number; bottom: number };

export function getHexBounds(verts: Point[]): Bounds {
    const xs = verts.map((v) => v.x);
    const ys = verts.map((v) => v.y);
    return {
        left: Math.min(...xs),
        right: Math.max(...xs),
        top: Math.min(...ys),
        bottom: Math.max(...ys),
    };
}
